import React from 'react';
import { Route, Routes } from 'react-router-dom';

import Home from '../screens/Home';
import RegisterRestaurant from '../screens/RegisterRestaurant';
import Login from '../screens/Login';
import MyAccount from '../screens/MyAccount';
import Restaurants from '../screens/Restaurants';
import RestaurantDetails from '../screens/RestaurantDetails';
import AddMenuItems from '../screens/AddMenuItems';
import OrderRequests from '../screens/OrderRequests';
import MyOrders from '../screens/MyOrders';
import MyFoods from '../screens/MyFoods';
import About from '../screens/About';
import Contact from '../screens/Contact';
import Faqs from '../screens/Faqs';
import PrivacyPolicy from '../screens/PrivacyPolicy';
import TnC from '../screens/TnC';
import DeleteAccount from '../screens/DeleteAccount';
import HowItWorks from '../screens/HowItWorks';

import NotFound from '../screens/NotFound';

// Routes For Navigation
const MyRoutes = () => (
    // <Router history={customHistory}>

    <div>
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/register-restaurant" element={<RegisterRestaurant />} />
            <Route path="/login" element={<Login />} />
            <Route path="/my-account" element={<MyAccount />} />
            <Route path="/restaurants" element={<Restaurants />} />
            <Route path="/restaurant-details" element={<RestaurantDetails />} />
            <Route path="/add-menu-items" element={<AddMenuItems />} />
            <Route path="/order-requests" element={<OrderRequests />} />
            <Route path="/my-orders" element={<MyOrders />} />
            <Route path="/my-foods" element={<MyFoods />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/tnc" element={<TnC />} />
            <Route path="/request-delete-account" element={<DeleteAccount />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faqs" element={<Faqs />} />
            <Route path="/how-it-works" element={<HowItWorks />} />

            <Route path="*" element={<NotFound />} />
        </Routes>
    </div>
    // </Router>
)

export default MyRoutes